import { configureStore } from '../core-bundle/store/create-store';

import transferUpload from '../transfer-bundle/store/initial-state';

// Import initial state helpers
import account from './helper/account';
import channel from './helper/channel';
import layout from './helper/layout';
import notification from './helper/notification';
import pending from './helper/pending';
import route from './helper/route';
import session from './helper/session';
import transfer from './helper/transfer';
import ui from './helper/ui';
import user from './helper/user';
import upload from './helper/upload';

import reducers from '@app/store/reducer';

// Create our initial state
const initialState = {
  // Some channel specific information
  channel,

  layout,

  // This contains notifications (if needed)
  notification,

  // Everything that is pending in our app is stored here
  pending,

  // Some account specific information
  account,

  // This contains the current route
  route,

  // Some session specific information
  session,

  // This contains the current Transfer object (up/down)
  // 1-to-1: A User can only have one active Transfer Object
  transfer,

  ui,

  billingDetails: {},

  invoices: null,

  apiGrants: [],

  // Some user specific information
  user,

  transferUpload,

  upload,
};

export default configureStore(initialState, reducers);
